import * as Sentry from '@sentry/react';
import { TanStackDevtools } from '@tanstack/react-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { useTranslation } from 'react-i18next';
import { Toaster } from '@/components/ui/sonner';
import TanStackQueryDevtools from '../integrations/tanstack-query/devtools';

interface MyRouterContext {
	queryClient: QueryClient;
}

function ErrorFallback() {
	const { t } = useTranslation();
	return (
		<div className='flex min-h-screen items-center justify-center p-4'>
			<p className='text-muted-foreground'>{t('error_boundary_fallback')}</p>
		</div>
	);
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			<Sentry.ErrorBoundary fallback={<ErrorFallback />}>
				<Outlet />
			</Sentry.ErrorBoundary>
			<Toaster />
			<TanStackDevtools
				config={{
					position: 'bottom-right',
				}}
				plugins={[
					{
						name: 'Tanstack Router',
						render: <TanStackRouterDevtoolsPanel />,
					},
					TanStackQueryDevtools,
				]}
			/>
		</>
	),
});
